import {
  SET_CURRENTLY_EDITING_SHOPPING_CART_LINE_DATA,
  SET_MAX_CONN_LEAD_TIME,
  SET_SHOPPING_CART_ID,
  SET_CART_LENGTH,
  SET_TRIGGER_SHOW_ADDED_TO_CART_MODAL,
  SET_TRIGGER_SHOW_CART_ITEM_EDITED_MODAL,
  TRIGGER_ADD_TO_SHOPPING_CART,
  TRIGGER_EDIT_CART_ITEM,
  TRIGGER_UPDATE_QUOTATION_LINE,
  SET_CURRENCY,
  SET_ADDITIONAL_CART_DETAILS,
  RESET_SHOPPING_CART,
  SET_QUOTATION_CART_ID,
} from 'store/constants';

export const resetShoppingCart = () => ({
  type: RESET_SHOPPING_CART,
});

export const triggerAddToShoppingCart = (trigger: boolean) => ({
  type: TRIGGER_ADD_TO_SHOPPING_CART,
  payload: trigger,
});

export const setCurrentlyEditingShoppingCartLineData = (
  id: number | null,
  quantity: number | null
) => ({
  type: SET_CURRENTLY_EDITING_SHOPPING_CART_LINE_DATA,
  payload: { id, quantity },
});

export const triggerEditCartItem = (trigger: boolean) => ({
  type: TRIGGER_EDIT_CART_ITEM,
  payload: trigger,
});

export const triggerUpdateQuotationLine = (trigger: boolean) => ({
  type: TRIGGER_UPDATE_QUOTATION_LINE,
  payload: trigger,
});

export const setMaxConnLeadTime = (maxConnLeadTime: number) => ({
  type: SET_MAX_CONN_LEAD_TIME,
  payload: maxConnLeadTime,
});

export const setAdditionalCartDetails = (additionalCartDetails: number) => ({
  type: SET_ADDITIONAL_CART_DETAILS,
  payload: additionalCartDetails,
});

export const setShoppingCartId = (shoppingCartId: string | null) => ({
  type: SET_SHOPPING_CART_ID,
  payload: shoppingCartId,
});

export const setQuotationCartId = (quotationCartId: string | null) => ({
  type: SET_QUOTATION_CART_ID,
  payload: quotationCartId,
});

export const setTriggerShowAddedToCartModal = (trigger: boolean) => ({
  type: SET_TRIGGER_SHOW_ADDED_TO_CART_MODAL,
  payload: trigger,
});

export const setTriggerShowCartItemEditedModal = (trigger: boolean) => ({
  type: SET_TRIGGER_SHOW_CART_ITEM_EDITED_MODAL,
  payload: trigger,
});

export const setCartLength = (cartLength: number) => ({
  type: SET_CART_LENGTH,
  payload: cartLength,
});

export const setCurrency = (currency: string) => ({
  type: SET_CURRENCY,
  payload: currency,
});
